import React from 'react';
import './Concept.css';
import dec_img from '../../img/main/bg.gif'
import { Link } from "react-scroll";

const Concept = () => {
    return (
        <div className="concept-wrap" id='concept'>
            <div className="container concept">
                <h2 className='concept-title colorful'>Idea and concept of this event</h2>
                <div className="concept-content">
                    <div className='concept-content_main'>
                        <img className="concept-img concept-item" src={dec_img} alt="" />
                        <div className='concept-text--block concept-item'>
                            <p className="concept-text p1">To stay updated with the latest Java Script trends and best practices across all popular frameworks, join the Java Script Global Summit 2023.</p>
                            <p className="concept-text p1">Learn from core teams and contributors of the most prominent technologies and join the community focused on Java Script development.</p>
                            <p className="concept-text p1">With a lineup of 24 speakers, six QA panels, and startup spotlights, this isn't your average online course. Prepare for a global gathering of over 3000 participants from around the globe, making this event an exciting opportunity to get new connections and meet experts from top companies like Microsoft, Adobe, AWS etc.</p>
                            <p className="concept-text p1">If you're eager to stay ahead of the competition in software development and learn about the latest JS advancements, it's time to join our community. So let's forge ahead together, boosting productivity and improving our skills.</p>
                            {/* <p className='concept-text concept-text--bold p1'>So, if you're serious about staying ahead of the curve with the latest AI tools in marketing, you gotta hit that button and join our community-driven conference. Let's make moves and level up our game together!</p> */}
                            {/* <p className='concept-text concept-text--bold p1'>And don't forget about the certificates - we got you covered, fam!</p> */}
                            <Link
                                activeClass="active"
                                to='tickets'
                                spy={true}
                                smooth={true}
                                offset={-94}
                                className='concept-btn button'
                            >
                                Join
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Concept;